var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamsTeamsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Streams_Teams_Active"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Streams_Teams_Active",
    "data-name": "Streams Teams_Active",
    clipPath: "url(#clip-Streams_Teams_Active)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Streams_Teams",
    "data-name": "Streams Teams",
    transform: "translate(1 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2193",
    "data-name": "Group 2193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2191",
    "data-name": "Group 2191",
    transform: "translate(0 7.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4796",
    "data-name": "Path 4796",
    d: "M14.985,18.4a.907.907,0,0,0-.012-.18,3.949,3.949,0,0,0-3.872-3.2H7.744a3.949,3.949,0,0,0-3.872,3.2c0,.06-.012.12-.012.18v2.086a.987.987,0,0,0,.983.983h9.171A.987.987,0,0,0,15,20.487V18.4Z",
    transform: "translate(-3.368 -14.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4797",
    "data-name": "Path 4797",
    d: "M14.084,22.031H4.913A1.461,1.461,0,0,1,3.45,20.568V18.482a1.028,1.028,0,0,1,.024-.276,4.431,4.431,0,0,1,4.352-3.6h3.357a4.431,4.431,0,0,1,4.352,3.6,1.968,1.968,0,0,1,.024.276v2.086A1.461,1.461,0,0,1,14.1,22.031Zm-6.258-6.45a3.467,3.467,0,0,0-3.4,2.805v2.17a.507.507,0,0,0,.5.5H14.1a.507.507,0,0,0,.5-.5V18.374a3.458,3.458,0,0,0-3.4-2.805H7.838Z",
    transform: "translate(-3.45 -14.61)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    "data-name": "Group 2192",
    transform: "translate(2.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4798",
    "data-name": "Path 4798",
    d: "M12.022,11.741A3.021,3.021,0,1,1,9,8.72,3.024,3.024,0,0,1,12.022,11.741Z",
    transform: "translate(-5.5 -8.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4799",
    "data-name": "Path 4799",
    d: "M9.081,15.321a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,9.081,15.321Zm0-6.042a2.541,2.541,0,1,0,2.541,2.541A2.543,2.543,0,0,0,9.081,9.279Z",
    transform: "translate(-5.58 -8.32)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    "data-name": "Group 2196",
    transform: "translate(17.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194",
    transform: "translate(0 7.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4800",
    "data-name": "Path 4800",
    d: "M30,18.4a.908.908,0,0,0-.012-.18,3.949,3.949,0,0,0-3.872-3.2H22.754a3.949,3.949,0,0,0-3.872,3.2c0,.06-.012.12-.012.18v2.086a.987.987,0,0,0,.983.983h9.171a.987.987,0,0,0,.983-.983V18.4Z",
    transform: "translate(-18.366 -14.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4801",
    "data-name": "Path 4801",
    d: "M29.084,22.031H19.913a1.461,1.461,0,0,1-1.463-1.463V18.482a1.028,1.028,0,0,1,.024-.276,4.431,4.431,0,0,1,4.352-3.6h3.357a4.431,4.431,0,0,1,4.352,3.6,1.968,1.968,0,0,1,.024.276v2.086A1.461,1.461,0,0,1,29.1,22.031Zm-6.258-6.45a3.467,3.467,0,0,0-3.4,2.805v2.17a.507.507,0,0,0,.5.5H29.1a.507.507,0,0,0,.5-.5v-2.17a3.458,3.458,0,0,0-3.4-2.805H22.838Z",
    transform: "translate(-18.45 -14.61)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195",
    transform: "translate(2.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4802",
    "data-name": "Path 4802",
    d: "M27.022,11.741A3.021,3.021,0,1,1,24,8.72,3.024,3.024,0,0,1,27.022,11.741Z",
    transform: "translate(-20.5 -8.24)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4803",
    "data-name": "Path 4803",
    d: "M24.081,15.321a3.5,3.5,0,1,1,3.5-3.5A3.5,3.5,0,0,1,24.081,15.321Zm0-6.042a2.541,2.541,0,1,0,2.541,2.541A2.543,2.543,0,0,0,24.081,9.279Z",
    transform: "translate(-20.58 -8.32)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2200",
    "data-name": "Group 2200",
    transform: "translate(8.107 1.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2198",
    "data-name": "Group 2198",
    transform: "translate(0 8.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4804",
    "data-name": "Path 4804",
    d: "M23.489,20.954a.907.907,0,0,0-.012-.18,4.555,4.555,0,0,0-4.472-3.7H15.134a4.545,4.545,0,0,0-4.472,3.7c0,.06-.012.12-.012.18v2.577a.987.987,0,0,0,.983.983H22.506a.987.987,0,0,0,.983-.983Z",
    transform: "translate(-10.17 -16.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4805",
    "data-name": "Path 4805",
    d: "M22.586,25.076H11.713a1.461,1.461,0,0,1-1.463-1.463V21.036a1.073,1.073,0,0,1,.024-.276,5.037,5.037,0,0,1,4.951-4.1H19.1a5.047,5.047,0,0,1,4.951,4.1,1.967,1.967,0,0,1,.024.276v2.577a1.461,1.461,0,0,1-1.463,1.463Zm-7.373-7.445a4.083,4.083,0,0,0-4,3.309v2.673a.507.507,0,0,0,.5.5H22.586a.507.507,0,0,0,.5-.5V20.94a4.064,4.064,0,0,0-4-3.309H15.213Z",
    transform: "translate(-10.25 -16.66)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199",
    transform: "translate(2.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4806",
    "data-name": "Path 4806",
    d: "M20.067,13.289A3.489,3.489,0,1,1,16.579,9.8,3.484,3.484,0,0,1,20.067,13.289Z",
    transform: "translate(-12.61 -9.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4807",
    "data-name": "Path 4807",
    d: "M16.658,17.336a3.968,3.968,0,1,1,3.968-3.968A3.973,3.973,0,0,1,16.658,17.336Zm0-6.965a3,3,0,1,0,3.009,3A3,3,0,0,0,16.658,10.371Z",
    transform: "translate(-12.69 -9.4)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamsTeamsActive);
export default __webpack_public_path__ + "static/media/Streams_Teams_Active.446d27a68e958ace368c8d1c72987b6e.svg";
export { ForwardRef as ReactComponent };